export var Widgets;
(function (Widgets) {
    Widgets["AUTH"] = "auth";
    Widgets["CHECKOUT"] = "checkout";
    Widgets["CONFIGURATOR"] = "configurator";
    Widgets["FINANCE_APPLICATION"] = "finance-application";
    Widgets["FINANCE_CALCULATOR"] = "finance-calculator";
    Widgets["MINI_FINANCE_CALCULATOR"] = "mini-finance-calculator";
    Widgets["INSURANCE_BLOCK"] = "insuranceblock";
    Widgets["MY_ACCOUNT"] = "my-account";
    Widgets["MINI_MY_ACCOUNT"] = "mini-my-account";
    Widgets["PAYMENT"] = "payment";
    Widgets["SALES_ENABLEMENT"] = "sales-enablement";
    Widgets["SINGPASS"] = "singpass";
    Widgets["STOCK_LOCATOR"] = "stock-locator";
    Widgets["TRADE_IN"] = "trade-in";
})(Widgets || (Widgets = {}));
//# sourceMappingURL=Wigets.js.map